import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/fold.svg';
const FoldIcon = (props) => React.createElement(IconSvg, { onClick: props.onClick });
export default FoldIcon;
